<template>
    <div class="table-head-tools-popup" :class="{show: columnData.showPopup}" v-on-clickaway="closePopup">
        <div v-if="columnData.sortable" class="table-sort">
            <label>{{ $t('global.toSort') }}</label>
            <div class="btns-container">
                <div class="table-head-tools-btn btn-sort-asc" :class="{active: columnData.activeSort === '+'}"
                     v-on:click="setSort(columnData,'+')">
                    <span class="fa-stack">
                        <i class="fa fa-long-arrow-down"></i>
                        <span class="fa-stack-text">A</span>
                        <span class="fa-stack-text">Z</span>
                    </span>
                </div>
                <div class="table-head-tools-btn btn-sort-desc" :class="{active: columnData.activeSort === '-'}"
                     v-on:click="setSort(columnData,'-')">
                    <span class="fa-stack">
                        <i class="fa fa-long-arrow-up"></i>
                        <span class="fa-stack-text">A</span>
                        <span class="fa-stack-text">Z</span>
                    </span>
                </div>
                <div class="table-head-tools-btn btn-sort-none" :class="{active: columnData.activeSort === false}"
                     v-on:click="setSort(columnData,false)">
                    <span class="fa-stack">
                        <i class="fa fa-times"></i>
                        <span class="fa-stack-text">A</span>
                        <span class="fa-stack-text">Z</span>
                    </span>
                </div>
            </div>
        </div>
        <div v-if="columnData.filter" class="table-filter">
            <label>{{ $t('global.toFilter') }}</label>
            <input v-if="columnData.filter.type == 'text'" type="text" class="form-input full-width"
                   :class="{active: columnData.activeFilter !== ''}" v-on:keyup="setFilter(columnData,true)"
                   v-model="currentFilter" :placeholder="columnData.filter.label || columnData.label"/>
            <select v-if="columnData.filter.type == 'list'" class="form-input full-width"
                    :class="{active: columnData.activeFilter !== ''}" v-on:change="setFilter(columnData,false)"
                    v-model="currentFilter">
                <option value=""></option>
                <option v-for="valueItem in columnData.filter.values" :key="valueItem.id" :value="valueItem.id"
                        :selected="valueItem.id == columnData.activeFilter ? 'selected' : ''">{{ valueItem.label }}
                </option>
            </select>
        </div>
    </div>

</template>

<script>
    import {mixin as clickaway} from 'vue-clickaway';
    import debounce from 'lodash/debounce'

    export default {
        name: 'tablefilterpopup',
        props: ['columnData'],
        mixins: [clickaway],
        data: () => ({
            currentFilter: null,
            _columnData: null,
            firstTime: true,
        }),
        watch: {

        },
        computed: {},
        methods: {
            setSort: function (column, sort) {
                this.$emit('sort', column, sort)
            },
            setFilter: function (column, debounce) {
                if(debounce){
                    this.debounceEmitFilter(column);
                }
                else{
                    this.$emit('filter', column, this.currentFilter)
                }

            },
            debounceEmitFilter: debounce(function (column) {
                this.$emit('filter', column, this.currentFilter)
            }, 500),
            closePopup: function (column) {
                if (this._columnData.showPopup && !this.firstTime) {
                    this._columnData.showPopup = false;
                    this.firstTime = true;
                }
                else {
                    this.firstTime = false;
                }


            }
        },
        created: function () {
            this._columnData = this.columnData;
            this.currentFilter = this.columnData.activeFilter;
        },
        update: function () {

        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/table/TableFilterPopup.vue